import React from 'react';
import styles from './SectionHeader.module.css';

/**
 * @component SectionHeader
 * @description 섹션 공통 헤더 (제목 + 부제목 + 액션)
 */
function SectionHeader({
  title,
  subtitle,
  align = 'center',
  layout = 'stacked',
  action,
  className = ''
}) {
  const headerClasses = [
    styles.sectionHeader,
    styles[align],
    styles[layout],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // layout이 split일 때는 좌우 분할 레이아웃
  if (layout === 'split') {
    return (
      <div className={headerClasses}>
        <div className={styles.headerLeft}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {action && <div className={styles.headerRight}>{action}</div>}
      </div>
    );
  }

  // 기본 stacked 레이아웃
  return (
    <div className={headerClasses}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {action && <div className={styles.headerAction}>{action}</div>}
    </div>
  );
}

export default SectionHeader;
